import { Component, ContentChild, input } from '@angular/core';

import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';
import { BadgeComponent } from '../badge/badge.component';
import { IconHelpComponent } from '../icon/icon-help/icon-help.component';
import { IconComponent } from '../icon/icon.component';
import { SparksAnimationComponent } from '../sparks-animation/sparks-animation.component';

@Component({
  selector: 'rt-heading',
  styleUrls: ['./heading.component.less'],
  templateUrl: './heading.component.html',
  host: {
    '[class.has-icon]': 'icon || sparksAnimation',
    '[class.truncated]': 'truncated()',
    '[class.has-text-color-red]': 'hasTextColorRed()',
    '[class.text-color-light]': 'hasTextColorLight()',
    '[class.correct-line-height]': 'hasCorrectLineHeight()',
    '[class]': 'variant()',
    '[class.text-wrap]': 'textWrap()',
  },
  imports: [],
})
export class HeadingComponent {
  public static readonly VARIANTS: Variants = [
    'heading',
    [
      'heading',
      'subheading',
      'large',
      'large-x',
      'large-x-dialog-header',
      'large-xx',
      'large-xxx',
      'uppercased',
      'block',
      'space-bottom',
      'icon-right',
      'text-color',
      'text-color-light',
      'small',
      'light',
      'normal',
      'dark',
      'align-center',
      'size-default',
      'lighter',
      'disabled',
      'semi-bold',
      'bold',
    ],
  ];

  public readonly variant = input(...ComponentVariantTransform(HeadingComponent.VARIANTS));

  public readonly showIcon = input<boolean>(true);
  public readonly truncated = input<boolean>(false);
  public readonly hasCorrectLineHeight = input<boolean>(false);
  public readonly hasTextColorLight = input<boolean>(false);
  public readonly hasTextColorRed = input<boolean>(false);
  public readonly textWrap = input<boolean>(false);

  @ContentChild(SparksAnimationComponent)
  public sparksAnimation: SparksAnimationComponent;
  @ContentChild(IconComponent)
  public icon: IconComponent;
  @ContentChild(IconHelpComponent, { static: false })
  public iconHelp: IconHelpComponent;
  @ContentChild(BadgeComponent, { static: false })
  public badge: BadgeComponent;
}
